import { useLocation } from "react-router-dom";
import { useMemo } from "react";

const useExtractSearchParams = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const individualParams = [
    "manufacturers",
    "modelGroups",
    "bodies",
    "modelExt",
    "fuellings",
    "drives",
    "transmissions",
    "usageTypes",
    "emissionClasses",
    "vatdeductible",
    "qualityseal",
    "metallic",
    "locations",
    "options",
    "powerType",
    "offerId",
    "paints",
    "bodyGroups",
    "upholsteries",
    "interiorColors",
    "promotions",
    "skip",
    "pageLayout",
    "variants",
    "series",
    "manufacturersType",
    "mileageMin",
    "mileageMax",
    "registerDateMin",
    "registerDateMax",
    "priceMin",
    "priceMax",
    "financingRateMin",
    "financingRateMax",
    "leasingRateMin",
    "leasingRateMax",
    "powerHpMin",
    "powerHpMax",
    "powerKwMin",
    "powerKwMax",
    "horsepowermin",
    "horsepowermax",
    "powermin",
    "powermax",
    "othermanufacturers",
  ];

  const multipleParams = new Set([
    "modelGroups",
    "bodies",
    "fuellings",
    "transmissions",
    "usageTypes",
    "emissionClasses",
    "locations",
    "options",
    "powerType",
    "offerId",
    "paints",
    "bodyGroups",
    "upholsteries",
    "interiorColors",
    "variants",
    "series",
    "manufacturersType",
    "models",
    "modelExt",
    "drives",
  ]);

  const transformToArray = (value) =>
    value ? value.split(",").map((s) => s.replace(/"/g, "")) : false;

  const extractedParams = useMemo(() => {
    const params = {};

    individualParams.forEach((key) => {
      const paramValue = searchParams.get(key) || false;
      params[key] = multipleParams.has(key)
        ? transformToArray(paramValue)
        : paramValue;
    });
    if (params.qualityseal) {
      params["hasqualityseal"] = params.qualityseal;
    }
    return params;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  return extractedParams;
};

export default useExtractSearchParams;
